// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { getMatmCustomer, searchMatmCustomers } from "../api/finkedaApi";
// import { useNotify } from "../context/NotifyContext";
// import { ListingPagination } from "./listing";

// const FILTERS = [
//   { value: "all", label: "All" },
//   { value: "mobile", label: "Mobile" },
//   { value: "account", label: "A/C No" },
//   { value: "pan", label: "PAN No" },
// ];

// const PLACEHOLDERS = {
//   all: "Search by mobile, name, account or PAN",
//   mobile: "Enter mobile number",
//   account: "Enter account number",
//   pan: "Enter PAN number",
// };

// const SENSITIVE_FILTERS = new Set(["account", "pan"]);
// const DEFAULT_FILTER = "mobile";
// const DEFAULT_LIMIT = 10;
// // const DEBOUNCE_MS = 280;

// function normalizeFilter(value) {
//   const v = String(value || "").toLowerCase();
//   return FILTERS.some((f) => f.value === v) ? v : DEFAULT_FILTER;
// }

// function parseUrlState(searchParams) {
//   const filter = normalizeFilter(searchParams.get("filter") || DEFAULT_FILTER);
//   const page = Math.max(1, Number(searchParams.get("page")) || 1);
//   const limit = Math.min(50, Math.max(1, Number(searchParams.get("limit")) || DEFAULT_LIMIT));
//   const q = SENSITIVE_FILTERS.has(filter)
//     ? ""
//     : String(searchParams.get("q") || "").trim();
//   return { filter, page, limit, q };
// }

// /**
//  * Customer directory: radio filter + search, card results, ListingPagination.
//  * Search state lives in the URL (except PAN / account values).
//  */
// const CustomerLookup = ({ onSelect, onNewCustomer }) => {
//   const { notify } = useNotify();
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [hasSearched, setHasSearched] = useState(false);
//   const initial = parseUrlState(searchParams);

//   const [filterType, setFilterType] = useState(initial.filter);
//   const [searchInput, setSearchInput] = useState(initial.q);
//   const [appliedQuery, setAppliedQuery] = useState(initial.q);
//   const [page, setPage] = useState(initial.page);
//   const [limit, setLimit] = useState(initial.limit);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [loadingId, setLoadingId] = useState(null);
//   const [selectedId, setSelectedId] = useState(null);
//   const skipDebounce = useRef(true);
//   const lastUrl = useRef(searchParams.toString());

//   const writeUrl = useCallback(
//     (filter, query, nextPage, nextLimit, replace = false) => {
//       setSearchParams(
//         (prev) => {
//           const next = new URLSearchParams(prev);
//           next.set("filter", filter);
//           if (nextPage > 1) next.set("page", String(nextPage));
//           else next.delete("page");
//           if (Number(nextLimit) !== DEFAULT_LIMIT) next.set("limit", String(nextLimit));
//           else next.delete("limit");
//           if (SENSITIVE_FILTERS.has(filter) || !query) next.delete("q");
//           else next.set("q", query);
//           next.delete("search");
//           lastUrl.current = next.toString();
//           return next;
//         },
//         { replace }
//       );
//     },
//     [setSearchParams]
//   );

//   const commit = useCallback(
//     ({
//       filter = filterType,
//       query = searchInput.trim(),
//       nextPage = 1,
//       nextLimit = limit,
//       replace = false,
//     } = {}) => {
//       const safeFilter = normalizeFilter(filter);
//       const safeQuery = String(query || "").trim();
//       setFilterType(safeFilter);
//       setAppliedQuery(safeQuery);
//       setPage(nextPage);
//       setLimit(nextLimit);
//       writeUrl(safeFilter, safeQuery, nextPage, nextLimit, replace);
//     },
//     [filterType, searchInput, limit, writeUrl]
//   );

//   useEffect(() => {
//     const key = searchParams.toString();
//     if (key === lastUrl.current) return;
//     lastUrl.current = key;
//     const parsed = parseUrlState(searchParams);
//     setFilterType(parsed.filter);
//     setPage(parsed.page);
//     setLimit(parsed.limit);
//     if (!SENSITIVE_FILTERS.has(parsed.filter)) {
//       skipDebounce.current = true;
//       setSearchInput(parsed.q);
//       setAppliedQuery(parsed.q);
//     }
//   }, [searchParams]);

//   // useEffect(() => {
//   //   if (skipDebounce.current) {
//   //     skipDebounce.current = false;
//   //     return undefined;
//   //   }
//   //   const t = setTimeout(() => {
//   //     commit({ query: searchInput.trim(), nextPage: 1, replace: true });
//   //   }, DEBOUNCE_MS);
//   //   return () => clearTimeout(t);
//   //   // commit is omitted so pagination / filter commits do not re-trigger search
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [searchInput]);

//   const fetchCustomers = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError("");
//       const res = await searchMatmCustomers({
//         query: appliedQuery,
//         filterType,
//         page,
//         limit,
//       });
//       if (!res.success) {
//         setRows([]);
//         setTotal(0);
//         setTotalPages(1);
//         setError(res.message || "Customer search failed");
//         return;
//       }
//       const payload = res.data || {};
//       const list = Array.isArray(payload) ? payload : payload.items || payload.rows || [];
//       const pagination = payload.pagination || {};
//       const count = pagination.total ?? res.total ?? list.length;
//       const pages =
//         pagination.totalPages ?? Math.max(1, Math.ceil(count / limit) || 1);
//       setRows(list);
//       setTotal(count);
//       setTotalPages(pages);
//     } catch {
//       setRows([]);
//       setTotal(0);
//       setTotalPages(1);
//       setError("Customer search failed");
//     } finally {
//       setLoading(false);
//     }
//   }, [appliedQuery, filterType, page, limit]);

//   // useEffect(() => {
//   //   fetchCustomers();
//   // }, [fetchCustomers]);

//   useEffect(() => {
//   if (!hasSearched) return;
//   fetchCustomers();
// }, [fetchCustomers, hasSearched]);

//   const handleFilterChange = (val) => {
//     skipDebounce.current = true;
//     const leavingSensitive = SENSITIVE_FILTERS.has(filterType);
//     const enteringPublic = !SENSITIVE_FILTERS.has(val);
//     const nextQuery = leavingSensitive && enteringPublic ? "" : searchInput.trim();
//     if (leavingSensitive && enteringPublic) setSearchInput("");
//     commit({ filter: val, query: nextQuery, nextPage: 1 });
//   };

//   // const handleSearchClick = () => {
//   //   skipDebounce.current = true;
//   //   commit({ query: searchInput.trim(), nextPage: 1 });
//   // };

//   const handleSearchClick = () => {
//   skipDebounce.current = true;
//   setHasSearched(true);

//   commit({
//     query: searchInput.trim(),
//     nextPage: 1,
//   });
// };

//   // const handleClear = () => {
//   //   skipDebounce.current = true;
//   //   setSearchInput("");
//   //   setSelectedId(null);
//   //   commit({ filter: DEFAULT_FILTER, query: "", nextPage: 1, nextLimit: DEFAULT_LIMIT });
//   // };

// const handleClear = () => {
//   skipDebounce.current = true;
//   setHasSearched(false);
//   setSearchInput("");
//   setSelectedId(null);
//   setRows([]);
//   setTotal(0);
//   setTotalPages(1);

//   commit({
//     filter: DEFAULT_FILTER,
//     query: "",
//     nextPage: 1,
//     nextLimit: DEFAULT_LIMIT,
//   });
// };
  
//   const pick = async (hit) => {
//     setLoadingId(hit.id);
//     const res = await getMatmCustomer(hit.id);
//     setLoadingId(null);
//     if (!res.success || !res.data) {
//       notify(res.message || "Could not load customer", "error");
//       return;
//     }
//     setSelectedId(hit.id);
//     onSelect?.(res.data);
//     notify("Customer details filled", "success");
//   };

//   const handleNew = () => {
//     setSelectedId(null);
//     onNewCustomer?.();
//   };

//   return (
//     <div className="ds-card p-4 h-full flex flex-col">
//       <div className="flex items-center justify-between mb-3">
//         <h3 className="text-[14px] font-semibold m-0">Customer Search</h3>
//         <button
//           type="button"
//           onClick={handleNew}
//           className="text-[12px] text-[var(--primary-color,#2563eb)] hover:underline"
//         >
//           + New customer
//         </button>
//       </div>

//       <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3">
//         {FILTERS.map((f) => (
//           <label
//             key={f.value}
//             className="flex items-center gap-1.5 text-[13px] cursor-pointer select-none"
//           >
//             <input
//               type="radio"
//               name="customerLookupFilter"
//               value={f.value}
//               checked={filterType === f.value}
//               onChange={() => handleFilterChange(f.value)}
//               className="accent-[var(--primary-color,#2563eb)]"
//             />
//             {f.label}
//           </label>
//         ))}
//       </div>

//       <div className="flex flex-col sm:flex-row gap-2 mb-3">
//         <input
//           type="search"
//           value={searchInput}
//           onChange={(e) => setSearchInput(e.target.value)}
//           onKeyDown={(e) => {
//             if (e.key === "Enter") {
//               e.preventDefault();
//               handleSearchClick();
//             }
//           }}
//           placeholder={PLACEHOLDERS[filterType]}
//           className="ds-input flex-1"
//           autoComplete="off"
//         />
//         <div className="flex gap-2 shrink-0">
//           <button type="button" className="ds-btn ds-btn-primary" onClick={handleSearchClick}>
//             Search
//           </button>
//           <button type="button" className="ds-btn ds-btn-secondary" onClick={handleClear}>
//             Clear
//           </button>
//         </div>
//       </div>

//       <div className="flex-1 min-h-fit">
//         {loading ? (
//           <p className="text-[13px] text-[var(--text-muted)] m-0 py-6 text-center">
//             Searching customers…
//           </p>
//         ) : error ? (
//           <p className="text-[13px] text-[var(--error-color)] m-0 py-2 text-center">{error}</p>
//         ) : rows.length === 0 ? (
//           <p className="text-[13px] text-[var(--text-muted)] m-0 py-2 text-center">
//             No customer found
//           </p>
//         ) : (
//           <div className="grid grid-cols-1 gap-2">
//             {rows.map((hit, index) => {
//               const selected = selectedId === hit.id;
//               return (
//                 <div
//                   key={hit.id || index}
//                   className={`border rounded-md p-3 ${
//                     selected
//                       ? "border-[var(--primary-color)] bg-[var(--primary-soft,#eff6ff)]"
//                       : "border-[var(--border-color)] bg-[var(--surface)]"
//                   }`}
//                 >
//                   <div className="flex items-start justify-between gap-2 cursor-pointer"  onClick={() => pick(hit)}
//                       disabled={loadingId === hit.id}>
//                     <div>
//                       <p className="font-semibold text-[13px] m-0">
//                         {hit.name ?? "--"}
//                       </p>
//                       <p className="text-[12px] text-[var(--text-muted)] m-0 mt-1">
//                         Mobile: {hit.mobileMasked ?? "--"}
//                       </p>
//                       <p className="text-[12px] text-[var(--text-muted)] m-0">
//                         Account Number: {hit.accountMasked || "--"}
//                       </p>
//                       <p className="text-[12px] text-[var(--text-muted)] m-0">
//                         PAN: {hit.panMasked ?? "--"}
//                       </p>
//                       <p className="text-[12px] text-[var(--text-muted)] m-0">
//                         Bank: {hit.bank ?? "--"}
//                       </p>
//                     </div>
//                     <button
//                       type="button"
//                       // onClick={() => pick(hit)}
//                       // disabled={loadingId === hit.id}
//                       className="ds-action-btn shrink-0"
//                     >
//                       {loadingId === hit.id ? "Loading…" : selected ? "Selected" : "Select"}
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>

//       {/* <ListingPagination
//         page={page}
//         limit={limit}
//         total={total}
//         totalPages={totalPages}
//         onPageChange={(nextPage) => commit({ query: appliedQuery, nextPage })}
//         onLimit={(nextLimit) =>
//           commit({ query: appliedQuery, nextPage: 1, nextLimit: Number(nextLimit) })
//         }
//       /> */}
//       {hasSearched && rows.length > 0 && (
//   <ListingPagination
//     page={page}
//     limit={limit}
//     total={total}
//     totalPages={totalPages}
//     onPageChange={(nextPage) =>
//       commit({
//         query: appliedQuery,
//         nextPage,
//       })
//     }
//     onLimit={(nextLimit) =>
//       commit({
//         query: appliedQuery,
//         nextPage: 1,
//         nextLimit: Number(nextLimit),
//       })
//     }
//   />
// )}
//     </div>
//   );
// };

// export default CustomerLookup;


import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { deleteMatmCustomer, getMatmCustomer, searchMatmCustomers } from "../api/finkedaApi";
import { useNotify } from "../context/NotifyContext";
import { ListingPagination } from "./listing";
import ConfirmDialog from "./ui/ConfirmDialog";

const FILTERS = [
  { value: "all", label: "All" },
  { value: "mobile", label: "Mobile" },
  { value: "account", label: "A/C No" },
  { value: "pan", label: "PAN No" },
];

const PLACEHOLDERS = {
  all: "Search by mobile, name, account or PAN",
  mobile: "Enter mobile number",
  account: "Enter account number",
  pan: "Enter PAN number",
};

const SENSITIVE_FILTERS = new Set(["account", "pan"]);
const DEFAULT_FILTER = "mobile";
const DEFAULT_LIMIT = 5;
// const DEBOUNCE_MS = 280;

function normalizeFilter(value) {
  const v = String(value || "").toLowerCase();
  return FILTERS.some((f) => f.value === v) ? v : DEFAULT_FILTER;
}

function parseUrlState(searchParams) {
  const filter = normalizeFilter(searchParams.get("filter") || DEFAULT_FILTER);
  const page = Math.max(1, Number(searchParams.get("page")) || 1);
  const limit = Math.min(50, Math.max(1, Number(searchParams.get("limit")) || DEFAULT_LIMIT));
  const q = SENSITIVE_FILTERS.has(filter)
    ? ""
    : String(searchParams.get("q") || "").trim();
  return { filter, page, limit, q };
}

/**
 * Customer directory: radio filter + search, card results, ListingPagination.
 * Search state lives in the URL (except PAN / account values).
 */
const CustomerLookup = ({ onSelect, onNewCustomer }) => {
  const { notify } = useNotify();
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasSearched, setHasSearched] = useState(false);
  const initial = parseUrlState(searchParams);

  const [filterType, setFilterType] = useState(initial.filter);
  const [searchInput, setSearchInput] = useState(initial.q);
  const [appliedQuery, setAppliedQuery] = useState(initial.q);
  const [page, setPage] = useState(initial.page);
  const [limit, setLimit] = useState(initial.limit);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [loadingId, setLoadingId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const skipDebounce = useRef(true);
  const lastUrl = useRef(searchParams.toString());

  const writeUrl = useCallback(
    (filter, query, nextPage, nextLimit, replace = false) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("filter", filter);
          if (nextPage > 1) next.set("page", String(nextPage));
          else next.delete("page");
          if (Number(nextLimit) !== DEFAULT_LIMIT) next.set("limit", String(nextLimit));
          else next.delete("limit");
          if (SENSITIVE_FILTERS.has(filter) || !query) next.delete("q");
          else next.set("q", query);
          next.delete("search");
          lastUrl.current = next.toString();
          return next;
        },
        { replace }
      );
    },
    [setSearchParams]
  );

  const commit = useCallback(
    ({
      filter = filterType,
      query = searchInput.trim(),
      nextPage = 1,
      nextLimit = limit,
      replace = false,
    } = {}) => {
      const safeFilter = normalizeFilter(filter);
      const safeQuery = String(query || "").trim();
      setFilterType(safeFilter);
      setAppliedQuery(safeQuery);
      setPage(nextPage);
      setLimit(nextLimit);
      writeUrl(safeFilter, safeQuery, nextPage, nextLimit, replace);
    },
    [filterType, searchInput, limit, writeUrl]
  );

  useEffect(() => {
    const key = searchParams.toString();
    if (key === lastUrl.current) return;
    lastUrl.current = key;
    const parsed = parseUrlState(searchParams);
    setFilterType(parsed.filter);
    setPage(parsed.page);
    setLimit(parsed.limit);
    if (!SENSITIVE_FILTERS.has(parsed.filter)) {
      skipDebounce.current = true;
      setSearchInput(parsed.q);
      setAppliedQuery(parsed.q);
    }
  }, [searchParams]);

  // useEffect(() => {
  //   if (skipDebounce.current) {
  //     skipDebounce.current = false;
  //     return undefined;
  //   }
  //   const t = setTimeout(() => {
  //     commit({ query: searchInput.trim(), nextPage: 1, replace: true });
  //   }, DEBOUNCE_MS);
  //   return () => clearTimeout(t);
  //   // commit is omitted so pagination / filter commits do not re-trigger search
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchInput]);

  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const res = await searchMatmCustomers({
        query: appliedQuery,
        filterType,
        page,
        limit,
      });
      if (!res.success) {
        setRows([]);
        setTotal(0);
        setTotalPages(1);
        setError(res.message || "Customer search failed");
        return;
      }
      const payload = res.data || {};
      const list = Array.isArray(payload) ? payload : payload.items || payload.rows || [];
      const pagination = payload.pagination || {};
      const count = pagination.total ?? res.total ?? list.length;
      const pages =
        pagination.totalPages ?? Math.max(1, Math.ceil(count / limit) || 1);
      setRows(list);
      setTotal(count);
      setTotalPages(pages);
    } catch {
      setRows([]);
      setTotal(0);
      setTotalPages(1);
      setError("Customer search failed");
    } finally {
      setLoading(false);
    }
  }, [appliedQuery, filterType, page, limit]);

  // useEffect(() => {
  //   fetchCustomers();
  // }, [fetchCustomers]);

  useEffect(() => {
  if (!hasSearched) return;
  fetchCustomers();
}, [fetchCustomers, hasSearched]);

  const handleFilterChange = (val) => {
    skipDebounce.current = true;
    const leavingSensitive = SENSITIVE_FILTERS.has(filterType);
    const enteringPublic = !SENSITIVE_FILTERS.has(val);
    const nextQuery = leavingSensitive && enteringPublic ? "" : searchInput.trim();
    if (leavingSensitive && enteringPublic) setSearchInput("");
    commit({ filter: val, query: nextQuery, nextPage: 1 });
  };

  // const handleSearchClick = () => {
  //   skipDebounce.current = true;
  //   commit({ query: searchInput.trim(), nextPage: 1 });
  // };

  const handleSearchClick = () => {
  skipDebounce.current = true;
  setHasSearched(true);

  commit({
    query: searchInput.trim(),
    nextPage: 1,
  });
};

  // const handleClear = () => {
  //   skipDebounce.current = true;
  //   setSearchInput("");
  //   setSelectedId(null);
  //   commit({ filter: DEFAULT_FILTER, query: "", nextPage: 1, nextLimit: DEFAULT_LIMIT });
  // };

const handleClear = () => {
  skipDebounce.current = true;
  setHasSearched(false);
  setSearchInput("");
  setSelectedId(null);
  setRows([]);
  setTotal(0);
  setTotalPages(1);

  commit({
    filter: DEFAULT_FILTER,
    query: "",
    nextPage: 1,
    nextLimit: DEFAULT_LIMIT,
  });
};
  
  const pick = async (hit) => {
    setLoadingId(hit.id);
    const res = await getMatmCustomer(hit.id);
    setLoadingId(null);
    if (!res.success || !res.data) {
      notify(res.message || "Could not load customer", "error");
      return;
    }
    setSelectedId(hit.id);
    onSelect?.(res.data);
    notify("Customer details filled", "success");
  };

  const handleDeleteClick = (hit, e) => {
    e.stopPropagation();
    setDeleteTarget(hit);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    const hit = deleteTarget;

    setDeletingId(hit.id);
    const res = await deleteMatmCustomer(hit.id);
    setDeletingId(null);

    if (!res.success) {
      notify(res.message || "Could not delete customer", "error");
      setDeleteTarget(null);
      return;
    }

    setRows((prev) => prev.filter((row) => row.id !== hit.id));
    setTotal((prev) => Math.max(0, prev - 1));
    if (selectedId === hit.id) setSelectedId(null);
    notify("Customer deleted", "success");
    setDeleteTarget(null);
  };

  const handleNew = () => {
    setSelectedId(null);
    onNewCustomer?.();
  };

  return (
    <>
    <div className="ds-card p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-[14px] font-semibold m-0">Customer Search</h3>
        <button
          type="button"
          onClick={handleNew}
          className="text-[12px]  hover:underline"
        >
          + New customer
        </button>
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3">
        {FILTERS.map((f) => (
          <label
            key={f.value}
            className="flex items-center gap-1.5 text-[13px] cursor-pointer select-none"
          >
            <input
              type="radio"
              name="customerLookupFilter"
              value={f.value}
              checked={filterType === f.value}
              onChange={() => handleFilterChange(f.value)}
              className="accent-[var(--primary-color,#2563eb)]"
            />
            {f.label}
          </label>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row gap-2 mb-3">
        <input
          type="search"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearchClick();
            }
          }}
          placeholder={PLACEHOLDERS[filterType]}
          className="ds-input flex-1"
          autoComplete="off"
        />
        <div className="flex gap-2 shrink-0">
          <button type="button" className="ds-btn ds-btn-primary" onClick={handleSearchClick}>
            Search
          </button>
          <button type="button" className="ds-btn ds-btn-secondary" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>

      <div className="flex-1 min-h-fit">
        {loading ? (
          <p className="text-[13px] text-[var(--text-muted)] m-0 py-6 text-center">
            Searching customers…
          </p>
        ) : error ? (
          <p className="text-[13px] text-[var(--error-color)] m-0 py-2 text-center">{error}</p>
        ) : rows.length === 0 ? (
          <p className="text-[13px] text-[var(--text-muted)] m-0 py-2 text-center">
            No customer found
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-2">
            {rows.map((hit, index) => {
              const selected = selectedId === hit.id;
              return (
                <div
                  key={hit.id || index}
                  className={`relative border rounded-md p-3 ${
                    selected
                      ? "border-[var(--primary-color)] ds-card"
                      : "border-[var(--border-color)] bg-[var(--surface)]"
                  }`}
                >
                  {hit.canDelete && (
                    <button
                      type="button"
                      title="Delete customer"
                      aria-label="Delete customer"
                      onClick={(e) => handleDeleteClick(hit, e)}
                      disabled={deletingId === hit.id}
                      className="absolute bottom-2 right-2 text-[var(--error-color,#dc2626)] hover:opacity-75 disabled:opacity-40 z-10"
                    >
                      {deletingId === hit.id ? (
                        <span className="text-[11px]">…</span>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          <path d="M10 11v6" />
                          <path d="M14 11v6" />
                          <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                        </svg>
                      )}
                    </button>
                  )}
                  <div className="flex items-start justify-between gap-2 cursor-pointer pb-5"  onClick={() => pick(hit)}
                      disabled={loadingId === hit.id}>
                    <div>
                      <p className="font-semibold text-[13px] m-0">
                        {hit.name ?? "--"}
                      </p>
                      <p className="text-[12px] text-[var(--text-muted)] m-0 mt-1">
                        Mobile: {hit.mobileMasked ?? "--"}
                      </p>
                      <p className="text-[12px] text-[var(--text-muted)] m-0">
                        Account Number: {hit.accountMasked || "--"}
                      </p>
                      <p className="text-[12px] text-[var(--text-muted)] m-0">
                        PAN: {hit.panMasked ?? "--"}
                      </p>
                      <p className="text-[12px] text-[var(--text-muted)] m-0">
                        Bank: {hit.bank ?? "--"}
                      </p>
                    </div>
                    <button
                      type="button"
                      // onClick={() => pick(hit)}
                      // disabled={loadingId === hit.id}
                      className="ds-action-btn shrink-0"
                    >
                      {loadingId === hit.id ? "Loading…" : selected ? "Selected" : "Select"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* <ListingPagination
        page={page}
        limit={limit}
        total={total}
        totalPages={totalPages}
        onPageChange={(nextPage) => commit({ query: appliedQuery, nextPage })}
        onLimit={(nextLimit) =>
          commit({ query: appliedQuery, nextPage: 1, nextLimit: Number(nextLimit) })
        }
      /> */}
      {hasSearched && rows.length > 0 && (
  <ListingPagination
    page={page}
    limit={limit}
    total={total}
    totalPages={totalPages}
    onPageChange={(nextPage) =>
      commit({
        query: appliedQuery,
        nextPage,
      })
    }
    onLimit={(nextLimit) =>
      commit({
        query: appliedQuery,
        nextPage: 1,
        nextLimit: Number(nextLimit),
      })
    }
  />
)}
    </div>
      <ConfirmDialog
        open={Boolean(deleteTarget)}
        title="Delete customer"
        message={`Are you sure you want to delete "${
          deleteTarget?.name || "this customer"
        }"? This cannot be undone.`}
        confirmLabel="Delete"
        confirmColor="error"
        loading={Boolean(deletingId)}
        onCancel={() => setDeleteTarget(null)}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default CustomerLookup;